import { action, observable } from 'mobx'

export default class AdminUIStore {

 @observable openChangePasswordDialog = false
 @observable openChangeMailDialog = false
 @observable openDeleteUserDialog = false
 @observable openCreateUserDialog = false
 @observable openPrimaryColorPopover = false
 @observable openAccentColorPopover = false
 @observable currentUser = {login:"",created:"",id:""}
 @observable inboxTab = 0
 @observable openEditItemDialog = false

 @action.bound selectInboxTab (tab) {
   this.inboxTab = tab
 }

 @action.bound handleOpenPrimaryColorPopover () {
   this.openPrimaryColorPopover = true
 }

 @action.bound handleClosePrimaryColorPopover () {
   this.openPrimaryColorPopover = false
 }

 @action.bound handleOpenAccentColorPopover () {
   this.openAccentColorPopover = true
 }

 @action.bound handleCloseAccentColorPopover () {
   this.openAccentColorPopover = false
 }

 @action.bound handleOpenCreateUserDialog () {
   this.openCreateUserDialog = true
 }

 @action.bound handleCloseCreateUserDialog () {
   this.openCreateUserDialog = false
 }

 @action.bound handleOpenChangePasswordDialog (user) {
   this.openChangePasswordDialog = true
   this.currentUser = user
 }

 @action.bound handleCloseChangePasswordDialog () {
   this.openChangePasswordDialog = false
 }

 @action.bound handleOpenChangeMailDialog (user) {
   this.openChangeMailDialog = true
   this.currentUser = user
 }

 @action.bound handleCloseChangeMailDialog () {
   this.openChangeMailDialog = false
 }

 @action.bound handleOpenDeleteUserDialog (user) {
   this.openDeleteUserDialog = true
   this.currentUser = user
 }

 @action.bound handleCloseDeleteUserDialog () {
   this.openDeleteUserDialog = false
 }

}



// WEBPACK FOOTER //
// ./src/stores/storeUIAdmin.js